import * as Sentry from '@sentry/browser';
import { RewriteFrames, CaptureConsole } from '@sentry/integrations';
import loadConfiguration from 'ggApp/utils/configuration';
import { spaFeatureFlag } from 'ggApp/modules/featureFlag/selectors';
import { SPA_FEATURE_FLAG_KEY } from 'ggApp/modules/featureFlag/constants';
import beforeSend from './middlewares/beforeSend';

export const initSentry = () => {
    const { SENTRY_DSN_CATALOG, SENTRY_ENV, SENTRY_RELEASE } = loadConfiguration();
    if (SENTRY_ENV && SENTRY_ENV !== 'development') {
        Sentry.init({
            dsn: SENTRY_DSN_CATALOG,
            environment: SENTRY_ENV,
            release: SENTRY_RELEASE,
            integrations: [new RewriteFrames(), new CaptureConsole({ levels: ['error'] })],
            ignoreErrors: [
                // Until Google Translate Error will not be fixed.
                // See: https://medium.com/@amir.harel/a-b-target-classname-indexof-is-not-a-function-at-least-not-mine-8e52f7be64ca
                'a[b].target.className.indexOf',
                // Issue is in sp.js script
                'Illegal invocation',
            ],
            beforeSend,
        });
    }

    try {
        // eslint-disable-next-line no-underscore-dangle
        const spaEnabled = spaFeatureFlag(window.__INITIAL_STATE__);
        Sentry.configureScope((scope) => {
            scope.setTag(SPA_FEATURE_FLAG_KEY, spaEnabled);
            scope.setTag('ReactNativeWebView', Boolean(window.ReactNativeWebView));
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Can't set a Sentry flag", e);
    }
};
